import { Provider, useSelector } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'

import { store, persistor } from './store/store'
import routes from './config/routes'
import AuthChecker from './components/auth/AuthChecker'
import Spinner from './components/utils/Spinner'
import { AuthListener } from './lib/listeners/authListener'
import { DataListener } from './lib/listeners/dataListener'
import { selectAuthStateKnown } from './store/slices/userSlice'
import {
  selectCurrentWorkspace,
  selectWorkspaces,
} from './store/slices/workspaceSlice'
import { WorkspaceType } from './lib/db/db.types'

function AppInner() {
  const authStateKnown = useSelector(selectAuthStateKnown)

  const currentWorkspace = useSelector(selectCurrentWorkspace)
  const workspaces = useSelector(selectWorkspaces)

  const workspace = workspaces.find((w) => w.id === currentWorkspace)

  if (!authStateKnown)
    return (
      <div className="h-auto flex justify-center items-center">
        <Spinner />
      </div>
    )

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <AuthChecker enforceAuth={route.protected}>
                <route.component />
              </AuthChecker>
            }
          />
        ))}

        {workspace?.spaceType === WorkspaceType.BUSINESS && (
          <Route
            path="/"
            element={
              <Navigate
                to={`/workspace/${workspace?.id}/calendar/`}
                replace={true}
              />
            }
          />
        )}

        <Route
          path="/workspace/:workspaceId"
          element={
            <Navigate
              to={`/workspace/${currentWorkspace}/calendar/`}
              replace={true}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <>
          <AuthListener />
          <DataListener />
        </>
        <Toaster />
        <AppInner />
      </PersistGate>
    </Provider>
  )
}

export default App
